<template>
  <div class="product-detail-container" v-if="product">
    <div class="detail-content">
      <!-- 产品主要信息 -->
      <div class="product-main">
        <!-- 左侧图片展示 -->
        <div class="product-images">
          <ImageMagnifier
            :images="allImages"
            :alt="product.title"
          />
        </div>

        <!-- 右侧产品信息 -->
        <div class="product-info">
          <h1 class="product-title">{{ product.title }}</h1>
          <div class="product-introduction">
            <div class="introduction-content" v-html="product.introduction"></div>
          </div>

          <!-- 价格展示模块 -->
          <div class="price-display">
            <span class="price-label">零售价：</span>
            <span class="price-value">{{ product.price || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 产品视频 -->
      <div class="product-video product-text" v-if="product.videoUrl">
        <h3>产品视频</h3>
        <div class="video-container">
          <video controls width="100%">
            <source :src="product.videoUrl" type="video/mp4">
            您的浏览器不支持视频播放。
          </video>
        </div>
      </div>

      <!-- 产品详情描述 -->
      <div class="product-description product-text" v-if="product.productDescription && product.productDescription.length > 0">
        <h3>产品描述</h3>
        <div class="description-images">
          <div
            v-for="(image, index) in product.productDescription"
            :key="index"
            class="description-image"
          >
            <img :src="image" :alt="`${product.title} 详情 ${index + 1}`" />
          </div>
        </div>
      </div>

      <!-- 关键词展示 -->
      <div class="keywords-section" v-if="product.keywords && product.keywords.length > 0">
        <div class="keywords-container">
          <span class="keywords-label">关键词：</span>
          <span
            v-for="(keyword, index) in product.keywords"
            :key="index"
            class="keyword-tag"
          >
            {{ keyword }}
          </span>
        </div>
      </div>
    </div>

    <!-- 分割线 -->
    <div class="divider-line" v-if="product"></div>

    <!-- 留言模块 -->
    <MessageForm :product-title="product ? product.title : ''" />
  </div>

  <div v-else class="error-container">
    <h2>产品未找到</h2>
    <p>抱歉，找不到您要查看的产品信息。</p>
  </div>
</template>

<script>
import exhibitionData from '@/data/exhibitionData'
import ImageMagnifier from './components/ImageMagnifier.vue'
import MessageForm from './components/MessageForm.vue'

export default {
  name: 'ProductDetail',
  components: {
    ImageMagnifier,
    MessageForm
  },
  data() {
    return {
      product: null
    }
  },
  computed: {
    allImages() {
      if (!this.product) return []

      // 只返回展示图片，不包含封面图
      return this.product.displayImages || []
    }
  },
  created() {
    this.loadProduct()
  },
  watch: {
    '$route'() {
      this.loadProduct()
    }
  },
  methods: {
    loadProduct() {
      const productId = parseInt(this.$route.params.id)
      this.product = exhibitionData.find(item => item.id === productId)

      if (this.product) {
        // 动态设置页面标题
        document.title = `${this.product.title} - 产品详情`
        // 更新路由meta信息 - 动态设置产品名称作为面包屑标题
        this.$route.meta.title = this.product.title
        // 使用Vue的响应式机制确保面包屑能监听到变化
        this.$nextTick(() => {
          // 触发路由变化事件，让面包屑组件重新获取标题
          this.$root.$emit('route-title-updated')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-detail-container {
  margin: 4% auto 8%;
  max-width: 1400px;
  padding: 0 20px;

  .detail-content {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
  }

  .product-main {
    display: flex;
    gap: 20px;
    padding: 40px;

    .product-images {
      //flex: 1;
      max-width: 600px;
    }

    .product-info {
      flex: 1;
      .product-title {
        font-size: 32px;
        color: #333;
        margin-bottom: 30px;
        font-weight: 600;
        line-height: 1.3;
      }

      .product-introduction {
        .introduction-content {
          font-size: 16px;
          line-height: 1.8;
          color: #666;

          // 富文本内容样式
          :deep(p) {
            margin-bottom: 16px;

            &:last-child {
              margin-bottom: 0;
            }
          }

          :deep(span) {
            font-size: 15px;
            line-height: 1.8;
          }

          :deep(br) {
            line-height: 1.8;
          }
        }
      }

      // 价格展示模块样式
      .price-display {
        background-color: #f2f2f2;
        padding: 15px 20px;
        border-radius: 6px;
        margin-top: 20px;
        display: flex;
        align-items: center;
        gap: 10px;

        .price-label {
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }

        .price-value {
          font-size: 18px;
          color: #e74c3c;
          font-weight: 600;
        }
      }
    }
  }

  .product-description {
    padding: 0 40px 40px 40px;

    .description-images {
      display: grid;
      gap: 30px;

      .description-image {
        text-align: center;

        img {
          max-width: 100%;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
  .product-text {
    h3 {
      width: 130px;
      height: 34px;
      text-align: center;
      font-size: 24px;
      color: #0555b6;
      margin-bottom: 30px;
      font-weight: 500;
      border-bottom: #0555b6 1px solid;
    }
  }

  .product-video {
    padding: 0 40px 40px 40px;

    .video-container {
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

      video {
        width: 100%;
        height: auto;
      }
    }
  }

  .keywords-section {
    padding: 0 40px 40px 40px;

    .keywords-container {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;

      .keywords-label {
        font-size: 24px;
        color: #333;
        font-weight: 500;
        margin-right: 8px;
      }

      .keyword-tag {
        background: #f8f8f8;
        color: #666;
        padding: 3px 12px;
        border-radius: 6px;
        font-size: 12px;
        border: 1px solid #e0e0e0;
        transition: all 0.3s ease;

        &:hover {
          background: #f0f0f0;
          border-color: #ccc;
        }
      }
    }
  }
}

.divider-line {
  width: 100vw;
  height: 1px;
  background-color: #e5e5e5;
  margin: 40px 0;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.error-container {
  text-align: center;
  padding: 80px 20px;

  h2 {
    font-size: 24px;
    color: #333;
    margin-bottom: 15px;
  }

  p {
    font-size: 16px;
    color: #666;
    margin-bottom: 30px;
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .product-detail-container {
    max-width: 1200px;

    .product-main {
      gap: 40px;
    }
  }
}

@media (max-width: 992px) {
  .product-detail-container {
    .product-main {
      flex-direction: column;
      gap: 30px;

      .product-images {
        max-width: 100%;
      }

      .product-info {
        .product-title {
          font-size: 28px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .product-detail-container {
    margin: 2% auto 4%;
    padding: 0 15px;

    .product-main {
      padding: 20px;
      gap: 20px;

      .product-info {
        .product-title {
          font-size: 24px;
          margin-bottom: 20px;
        }

        .product-introduction {
          .introduction-content {
            font-size: 15px;
            line-height: 1.6;

            :deep(span) {
              font-size: 14px;
            }
          }
        }
      }
    }

    .product-description,
    .product-video {
      padding: 20px;

      h3 {
        font-size: 20px;
        margin-bottom: 20px;
      }
    }
  }
}

@media (max-width: 480px) {
  .product-detail-container {
    padding: 0 10px;

    .product-main {
      padding: 15px;

      .product-info {
        .product-title {
          font-size: 20px;
        }
      }
    }

    .product-description,
    .product-video {
      padding: 15px;
    }
  }
}
</style>
